import * as React from 'react';
import type { NumberFieldElement } from '../../../../types/form/Element';
import {
  useFormSubmitterContext,
  FORM_SUBMITTER_ACTIONS,
} from '../../form-submitter-context';
import NumberFieldSubmitter from './number-field-submitter';
import { RequiredMark } from '../../../../common/components/required-mark';

type Props = {
  description?: Node;
  element: NumberFieldElement;
};

const NumberFieldWithContext = (props: Props) => {
  const { element, description } = props;
  const { id, disabled, required, label } = element;
  const {
    state,
    dispatch,
    selector: { getErrorForId, getTextValueForId },
  } = useFormSubmitterContext();
  const { submitInProgress } = state;
  const isDisabled = submitInProgress;

  const error = getErrorForId(state, id);
  const value = getTextValueForId(state, id);

  /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
  const handleChange = (newValue: any) => {
    dispatch({
      id,
      type: FORM_SUBMITTER_ACTIONS.NUMBER_FIELD_ON_CHANGE,
      newValue,
    });
  };

  const renderLabel = required ? (
    <>
      {label} <RequiredMark />
    </>
  ) : (
    label
  );

  return (
    <NumberFieldSubmitter
      // @ts-expect-error [MIGRATION-SUPPRESSION]: TS2322
      description={description}
      error={error}
      isDisabled={disabled || isDisabled}
      isRequired={required}
      label={renderLabel}
      onChange={handleChange}
      value={value}
    />
  );
};

export { NumberFieldWithContext };
export default NumberFieldWithContext;
